module.exports = __webpack_public_path__ + "pc/img/puzzle_01.deed5945.png";